import { List, Create, Upload } from "../Components/index.js";

export default [
    {
        path: "/file/archive",
        component: List,
        name: "file.archive",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/file/archive/create",
        component: Create,
        name: "file.archive.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/file/archive/upload/:id",
        component: Upload,
        name: "file.archive.upload",
        meta: {
            requiresAuth: true,
        },
    },
];
